import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from 'react-redux';
import ACTION_TYPES from 'redux-lib/actions/actions';
import GRAPHQL_API from 'api/graphql';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      paddingTop: 16
    }
  },
  loader: {
    width: '15px !important',
    height: '15px !important',
    marginTop: 5
  }
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        const { value, formattedValue, floatValue } = values;
        onChange({
          target: {
            name: props.name,
            value: floatValue,
          },
        });
      }}
      allowLeadingZeros={ false }
      allowNegative={ false }
      thousandSeparator
      prefix="P "
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default function FMV() {

  const classes = useStyles();
  
  const dispatch = useDispatch();
  const states = useSelector(state => {
    return state.globalStates
  })

  const car_brand = states ? states.car_brand ? states.car_brand : "" : "";
  const car_model = states ? states.car_model ? states.car_model : "" : "";
  const car_year = states ? states.car_year ? parseInt(states.car_year) : "" : "";
  const car_trim = states ? states.car_trim ? states.car_trim : "" : "";
  const car_id = states ? states.car_id ? parseInt(states.car_id) : "" : "";
  const depreciation = states ? states.depreciation ? states.depreciation === 'None' ? 'None' : parseInt(states.depreciation) : 0 : 0;
  const fmv = states ? states.fmv ? parseInt(states.fmv) : "" : "";

  // useEffect(() => {
    
  // }, [fmv])

  // useEffect(() => {
  //   getFMV();
  // }, [car_year, car_brand, car_model, car_trim, car_id])

  // const getFMV = (cb) => {
  //   const q = `{
  //     get_car_fair_market_value( brand: "${ car_brand }", model: "${ car_model }", year: ${ car_year }, trim: "${ car_trim }" ) {
  //       car_id
  //       fair_market_value
  //     }
  //   }`;
  //   GRAPHQL_API.graph(q).then(data => {
  //     if( data ) {
  //       dispatch({
  //         type: ACTION_TYPES.UPDATE_CAR_ID,
  //         payload: data.data.get_car_fair_market_value ? data.data.get_car_fair_market_value.car_id : 0
  //       })
  //       dispatch({
  //         type: ACTION_TYPES.UPDATE_FMV,
  //         payload: data.data.get_car_fair_market_value ? data.data.get_car_fair_market_value.fair_market_value : 0
  //       })
  //       dispatch({
  //         type: ACTION_TYPES.UPDATE_INITIAL_FMV,
  //         payload: data.data.get_car_fair_market_value ? data.data.get_car_fair_market_value.fair_market_value : 0
  //       })
  //       if( data.data.get_car_fair_market_value ) {
  //         getCar();
  //       }
  //     }
  //   })
  // }

  const getCar = () => {
    const q = `{
      get_car(car_id:${ car_id }) {
        title
        brand
        model
        trim
        body_type
        car_type
        number_of_seats
        special_quote
      }
    }`;
    GRAPHQL_API.graph(q).then(data => {
      if( data ) {
        dispatch({
          type: ACTION_TYPES.UPDATE_BODY_TYPE,
          payload: data.data.get_car ? data.data.get_car.body_type : ""
        })
        dispatch({
          type: ACTION_TYPES.UPDATE_CAR_TYPE,
          payload: data.data.get_car ? data.data.get_car.car_type : ""
        })
        dispatch({
          type: ACTION_TYPES.UPDATE_SPECIAL_QUOTE,
          payload: data.data.get_car ? data.data.get_car.special_quote : ""
        })
      }
    })
  }

  const handleChange = (event) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_FMV,
      payload: event.target.value
    })
  };

  const handleKeyUp = (event) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_MANUAL_FMV,
      payload: fmv
    })
    dispatch({
      type: ACTION_TYPES.UPDATE_IS_ON_MANUAL_FMV,
      payload: true
    })
    dispatch({
      type: ACTION_TYPES.UPDATE_DEPRECIATION,
      payload: ""
    })
  };

  const clearStates = (statesToClear) => {
    statesToClear.forEach((state) => {
      dispatch({
        type: `UPDATE_${ state.toUpperCase() }`,
        payload: ""
      })
    })
  }

  return (
    <div className={classes.root}>
      <TextField
        label="Fair Market Value"
        value={fmv}
        onChange={handleChange}
        onKeyUp={handleKeyUp}
        name="fmv"
        id="fair-market-value"
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
        InputLabelProps={{
          shrink: true
        }}
      />
      {
        states.is_loading ? 
        <CircularProgress className={ classes.loader } />
        :
        <div className={ `fmv-helpers ${ states.initial_fmv || states.manual_fmv ? 'active' : '' }` }>
        { states.initial_fmv ?   
          <small style={{ fontSize: 11 }}>
            <span>Offered Price:</span>&nbsp;
            <span>P { states.initial_fmv.toLocaleString()  }</span><br/>
          </small>
        : "" }
        { states.suggested_price ?   
          <small style={{ fontSize: 11 }}>
            <span>PIRA Price:</span>&nbsp;
            <span>P { states.suggested_price.toLocaleString()  }</span><br/>
          </small>
        : "" }
        { states.manual_fmv ? 
          <small style={{ fontSize: 11 }}>
            <span>Manual Price:</span>&nbsp;
            <span>P { states.manual_fmv.toLocaleString()  }</span><br/>
          </small>
        : "" }
          {
            depreciation !== 0 ? 
            <small style={{ fontSize: 11 }}>
              {
                depreciation === 'None' ?
                <span>Depreciated by:&nbsp;{ depreciation  }</span> : <span>Depreciated by:&nbsp;{ depreciation.toLocaleString()  }&#37;</span>
              }
            </small>
            : ''
          }
        </div>
      }
    </div>
  );
}